import React from 'react';
import { Box, Text, Image, Button, Flex, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { resetState, setCurrentStep, fetchLocationsSuccess, fetchLocationsFailure } from '../reducers/LocationSlice';
import { fetchLocationsApi } from '../api/api';
import { useTranslation } from 'react-i18next';
import kiidoLogo from '../assets/images/kiido.svg';
import citheaLogo from '../assets/images/cithea.jpeg';
import googlePlay from '../assets/images/google_play.jpeg';
import appStore from '../assets/images/app_store.jpeg';
import Utils from '../services/Utils';


const Confirmation = ({ isOpen, onClose, data }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { locationName, date, time, fileNumber, consultation_mode } = data || {};

  const handleReset = async () => {
    //dispatch(resetState()); // Dispatch the reset action
    //onClose(); // Close the modal
    // dispatch(setCurrentStep(1)); // Set the current step to 1
    // try {
    //   const data = await fetchLocationsApi();
    //   dispatch(fetchLocationsSuccess(data));
    //   console.log("Fetched Locations: ", data); // Log the locations
    // } catch (error) {
    //   dispatch(fetchLocationsFailure(error.message));
    //   console.error("Error fetching locations: ", error);
    // }
    // window.location.href = 'https://kiido.fr/'; // Redirect to the specified URL
  };

  const handleClose = () => {
    onClose();
    // window.location.href = 'https://kiido.fr/'; // Redirect to the specified URL
  };

  return (
    // how to make to modal component to up to 70% of the screen

    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay backdropFilter="blur(10px)" />
      <ModalContent maxWidth={{ base: '100%', md: '60%' }} mx={{ base: '1rem', md: 'auto' }}>
        <ModalHeader textAlign="center">
          <Image src={kiidoLogo} alt="Kiido Logo" mb={4} mt={4} mx="auto" />
        </ModalHeader>
        <ModalBody textAlign="center">
          <Text fontSize="lg" mb={2}>
            {t('content.confirmation.title')}
          </Text>
          <Image src={citheaLogo} alt="Cithéa Logo" mb={4} mt={6} mx="auto" />
          {locationName ? <Text fontWeight="bold" color="red.500">
            {t('content.confirmation.location')}: {locationName}
          </Text> : <Text fontWeight="bold" color="red.500">
            {t('consultation_mode')}: {consultation_mode}
          </Text>}

          <Text fontWeight="bold" color="red.500">
            {t('content.confirmation.date')}: {date}
          </Text>
          <Text fontWeight="bold" color="red.500">
            {t('content.confirmation.time')}: {Utils.convertUTCToLocalTimeZone(time)}
          </Text>
          <Text fontWeight="bold" color="red.500">
            {t('content.confirmation.file_number')}: {fileNumber}
          </Text>
          <Text fontSize="sm" color="gray.600" mt={4}>
            {t('content.confirmation.note')}
          </Text>
        </ModalBody>
        <ModalFooter display="flex" flexDirection="column" alignItems="center">
          <Button
            bg="red.500"
            color="white"
            mt={4}
            _hover={{ bg: 'red.400' }}
            onClick={handleReset} // Use handleReset function
            width="100%"
          >
            {t('content.confirmation.button_text')}
          </Button>
          <Text fontWeight="bold" mt={12}>
            {t('content.confirmation.slogan')}
          </Text>
          <Flex mt={4} justifyContent="center">
            <a href="https://play.google.com/store/apps/details?id=fr.kiido.kiido" target="_blank" rel="noopener noreferrer">
              <Image src={googlePlay} alt="Google Play" height={'60px'} width={'200px'} />
            </a>
            <a href="https://apps.apple.com/fr/app/kiido/id6444884424" target="_blank" rel="noopener noreferrer">
              <Image src={appStore} alt="App Store" ml={4} height={'60px'} width={'200px'} />
            </a>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default Confirmation;
